module.exports = {
      id: "follow-usage",
      viewBox: "0 0 129 42",
      url: __webpack_public_path__ + "svg-sprite-1d11361007108583c67c4a96e18e035a.svg#follow",
      toString: function () {
        return this.url;
      }
    }